import { CheckoutContext } from '@/context/CheckoutContext';
import { DrawerScreen } from '@/types/screens';
import { useContext } from 'react';
import { useTranslate } from '@/hooks/useTranslate';
import { useScreenSurface } from '@/hooks/useScreenSurface';
import Plus from '@/assets/icons/common/plus.svg';
import { getMixpanelProperties } from '@/utils/mixpanelProperties';
import { mixpanelService } from '@/services/mixpanelService';
import { MixpanelEvents } from '@/constants/mixpanelEvents';
import { logInfo } from '@/utils/logger';
import { InfoLogs } from '@/constants/logs';
import { getLogInfoData } from '@/utils/logs';

export const DifferentCardButton = () => {
  const context = useContext(CheckoutContext);
  const {
    card: { savedCards },
  } = context;
  const { t } = useTranslate();
  const { openScreen } = useScreenSurface();

  const handleClick = () => {
    const properties = getMixpanelProperties(context);
    mixpanelService.track(MixpanelEvents.ADD_OR_CHANGE_CARD_CLICKED, properties as Record<string, unknown>);
    logInfo(InfoLogs.addOrChangeCardClicked, getLogInfoData(context));
    openScreen(cardsCount === 1 ? DrawerScreen.NEW_CARD : DrawerScreen.SAVED_CARDS);
  };

  const cardsCount = savedCards.length;
  const text = cardsCount === 1 ? t('newCard') : t('changeOrAddCard');
  return (
    <div className="flex flex-row h-11 w-full items-center gap-3 rounded-xl cursor-pointer" onClick={handleClick}>
      <div className="flex flex-row items-center gap-2">
        <img src={Plus} className="w-4 h-4" />
        <div className="text-sm color-primary font-medium">{text}</div>
      </div>
    </div>
  );
};
